import { RiExternalLinkLine } from "react-icons/ri";

const HostingEvidenceNote = ({ countryValues, evidence, t }) => {
  const selectedCountries = new Set((countryValues || []).map(String));
  const relevantEvidence = (evidence || []).filter(
    (item) =>
      !Array.isArray(countryValues) ||
      selectedCountries.has(String(item?.country?.value))
  );
  const sources = relevantEvidence.flatMap((item) =>
    (item?.sources || []).map((source) => ({
      country: item?.country?.title,
      ...source,
    }))
  );

  if (!sources.length) {
    return null;
  }

  return (
    <div className="software-hosting-evidence">
      {sources.map((source, index) => (
        <div className="software-hosting-evidence__item" key={index}>
          {source.evidence && (
            <span>
              {t("AI evidence")}: {source.evidence}
            </span>
          )}
          {source.url && (
            <span>
              {t("Source")}:{" "}
              <a href={source.url} target="_blank" rel="noopener noreferrer">
                {source.type || source.country || source.url}
                <RiExternalLinkLine aria-hidden="true" />
              </a>
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default HostingEvidenceNote;
